module.exports = __webpack_public_path__ + "img/list.26dd3690.png";